import { render } from "./ErrorThrowerDev.vue?vue&type=template&id=8678972a"
import script from "./ErrorThrowerDev.vue?vue&type=script&lang=js"
export * from "./ErrorThrowerDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__